import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {RouteService} from '../../../services/route/route.service';
import {CartService} from '../../../services/cart/cart.service';
import {EventService} from '../../../services/event/event.service';
import {AuthService} from '../../../services/auth/auth.service';
import {EventDetailsDialogComponent} from '../../../components/event-details-dialog/event-details-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {Event, Sector, LegacyTicket, TicketIds, CartEvent, EventLocationType, EventStateEnum} from '../../../generated/sales-terminal-client';
import {cloneDeep} from 'lodash-es';
import {PricePipe} from '../../../pipes/price/price.pipe';
import {TranslateService} from '@ngx-translate/core';
import {LanguageService} from '../../../services/language/language.service';
import {SnackService} from '../../../services/snack/snack.service';
import {StorageService} from '../../../services/storage/storage.service';
import {RefundService} from '../../../services/refund/refund.service';
import {UtilService} from '../../../services/util/util.service';
import {Subscription, tap} from 'rxjs';
import {ViewService} from '../../../services/view/view.service';
import {
  STATUS_CANCELLED,
  STATUS_DRAFT,
  STATUS_PAST,
  STATUS_SUSPENDED
} from '../event-search/event-search.constants';
import {RefundDialogComponent} from './refund-dialog/refund-dialog.component';
import {DetailedSector} from './ticket-select/ticket-select.component';
import {finalize} from 'rxjs/operators';
import {BookingsService} from '../../../services/bookings/bookings.service';
import moment from 'moment';
import {Privileges} from '../../admin/privileges/privileges.constants';
import {CartTypes} from '../../../services/cart/cart-base.service';
import {TO_EVENT_BO_VIEW} from '../sales-terminal.constants';
import {EventProps} from '../../../components/event-info-props/event-info-props.component';

@Component({
  selector: 'app-event-purchase',
  templateUrl: './event-purchase.component.html',
  styleUrls: ['./event-purchase.component.scss'],
  providers: [PricePipe]
})
export class EventPurchaseComponent implements OnInit, OnDestroy {
  public static STORAGE_EVENT_PURCHASE_ID: string = 'eventPurchase.id';
  public static STORAGE_EVENT_IS_BO: string = 'eventPurchase.boEvent';

  @Output() public searchEvent: EventEmitter<string> = new EventEmitter<string>();

  public hideContent: boolean;
  public isLoading = false;
  public purchaseSucceed = false;
  public isSeason = false;
  public isPartOfSeason = false;
  public refundMode: boolean;
  public salespointHasRefundRight: boolean;
  public event: Event = {};
  public eventSectors: Sector[] = [];
  public selectedSector: DetailedSector;
  public selectedSeatIds: number[] = [];
  public deselectedSeatIds: number[] = [];
  public Privileges = Privileges;
  public isOwnerCenter: boolean;
  public EventLocationType = EventLocationType;
  public eventProps: EventProps;

  private _eventId: number;
  private _subscriptions: Subscription[] = [];
  private _finished = false;
  private _scrollTop: number = 0;

  constructor(
    public dialog: MatDialog,
    public routeService: RouteService,
    public viewService: ViewService,
    public utilService: UtilService,
    public cartService: CartService,
    public authService: AuthService,
    private eventService: EventService,
    private translateService: TranslateService,
    private snackService: SnackService,
    private storageService: StorageService,
    private languageService: LanguageService,
    private refundService: RefundService,
    private bookingsService: BookingsService) {
  }

  public ngOnInit(): void {
    this.initEventDetails();
    this._subscriptions.push(this.utilService.translationsLoadedChange.subscribe(res => {
      if (res) {
        this.initEventDetails();
      }
    }));
    if (!this.routeService.isWindow) {
      this.storageService.remove(CartService.STORAGE_CART_UPDATE);
      this.storageService.remove(CartService.STORAGE_CART_CHECKOUT);
      this.storageService.remove(CartService.STORAGE_CART_PURCHASE_SUCCEED);
      this.storageService.remove(CartService.STORAGE_CART_UPDATE_SUBTOTALS);
    } else if (!this.storageService.get(EventPurchaseComponent.STORAGE_EVENT_PURCHASE_ID)) {
      this.hideContent = true;
      this.viewService.triggerCdr();
    }
    if (this.cartService.cartSubscription) {
      this.cartService.cartSubscription.add(() => this.updateCartForPurchase());
    } else {
      this.cartService.cartSubscription = this.cartService.getCart().subscribe(() => this.updateCartForPurchase());
      this._subscriptions.push(this.cartService.cartSubscription);
    }
    this._subscriptions.push(this.storageService.changes.subscribe(({key, value}) => {
      if (key === RouteService.STORAGE_ROUTE_IS_PURCHASE_VIEW && this.routeService.isWindow) {
        this.hideContent = !value || !parseInt(value, 0);
        if (this.hideContent) {
          this.storageService.remove(EventPurchaseComponent.STORAGE_EVENT_PURCHASE_ID);
          this.storageService.remove(EventPurchaseComponent.STORAGE_EVENT_IS_BO);
          this.viewService.triggerCdr();
        }
      }
      if (key === EventPurchaseComponent.STORAGE_EVENT_PURCHASE_ID && this.routeService.isWindow) {
        if (value > 0) {
          this.hideContent = false;
          this.storageService.set(RouteService.STORAGE_ROUTE_IS_PURCHASE_VIEW, value);
          this.viewService.triggerCdr();
        }
      }
      if (key === CartService.STORAGE_CART_UPDATE) {
        if (this.cartService.caller) {
          this.cartService.caller = false;
        } else if (value) {
          this.startLoader();
          this.cartService.getCart().pipe(
            finalize(() => {
              this.stopLoader();
              this.storageService.remove(CartService.STORAGE_CART_UPDATE);
              this.viewService.triggerCdr();
            })
          ).subscribe(() => this.updateCartForPurchase());
        }
      }
      if (key === CartService.STORAGE_CART_CHECKOUT && !this.routeService.isWindow) {
        if (value) {
          this.storageService.remove(CartService.STORAGE_CART_CHECKOUT);
          this.routeService.navigate('/app/sales-terminal/cart');
        }
      }
      if (key === CartService.STORAGE_CART_PURCHASE_SUCCEED) {
        if (value) {
          this.purchaseSucceed = true;
          setTimeout(() => {
            this.purchaseSucceed = false;
            this.hideContent = true;
            this.viewService.triggerCdr();
          }, 30000);
        }
      }
      if (key === LanguageService.STORAGE_LANGUAGE_SELECTED && this.routeService.isWindow) {
        if (value) {
          this.languageService.changeLang(value);
        }
      }
      this.viewService.triggerCdr();
    }));
  }
  public ngOnDestroy(): void {
    this._subscriptions.forEach(s => s.unsubscribe());
    this._subscriptions = [];
  }
  public updateCartForPurchase(isCaller = false): void {
    if (isCaller) {
      this.cartService.caller = true;
      this.storageService.set(CartService.STORAGE_CART_UPDATE, moment.now());
    }
    this.cartService.updateCartForEvent(this._eventId);
    this.updateSeats();
    if (this.routeService.isWindow) {
      if (this.hideContent && this.cartService.isEmpty) {
        window.close();
      }
      window.resizeTo(screen.availWidth, screen.availHeight);
    }
  }

  public initEventDetails(): void {
    this._eventId = parseFloat(this.routeService.params['id']);
    this.startLoader();
    this.eventService.getEvent(this._eventId).pipe(
      tap({error: () => {
        this.routeService.replaceUrl('app/sales-terminal');
        this.stopLoader();
      }})
    ).subscribe(currentEvent => {
      this.event = currentEvent;
      this.eventProps = {
        eventPeriod: this.event.event,
        timezone: this.event.timezone,
        venueTitle: this.event.venueTitle,
        onlineLocation: this.event.onlineLocation
      };
      this.isSeason = this.event.eventId === this.event.seasonId;
      this.isPartOfSeason = this.event.seasonId && this.event.eventId !== this.event.seasonId;
      if (this.cartService.isEmpty) {
        if (this.event.boEvent) {
          this.cartService.cartType = CartTypes.SelfService;
        } else {
          this.cartService.cartType = CartTypes.Legacy;
        }
      }
      if (this.authService.hasReportingPromoterMyEventsPrivilege) {
        this.eventService.isOwner([this._eventId]).subscribe((res) => {
          this.isOwnerCenter = res.allowed;
        });
      }
      if (!this.hasAllowedStatus || !this.hasAllowedState) {
        this.routeService.navigate('/app/sales-terminal');
        if (this.event.status.id === STATUS_DRAFT) {
          this.snackService.showError(this.translateService.instant('general.api_event_is_in_preparation'));
        }
        if (this.event.status.id === STATUS_PAST || this.event.status.id === STATUS_CANCELLED || this.event.status.id === STATUS_SUSPENDED) {
          this.snackService.showError(this.translateService.instant('general.api_event_status_invalid'));
        }
        if (this.event.boEvent && this.eventService.isSaleStartsFuture(this.event.sale?.start)) {
          this.snackService.showError(this.translateService.instant('general.api_event_tickets_sale_period_not_started'));
        }
        else if (this.event.assignedStates.includes(EventStateEnum.SoldOut) || this.event.assignedStates.includes(EventStateEnum.TicketsCurrentlyUnavailable)) {
          this.snackService.showError(this.translateService.instant('general.api_event_tickets_none_available'));
        }
      } else if (this.eventService.isHiddenEvent(this.event) && !this.eventService.canAccessHiddenEvent) {
        this.routeService.navigate('/app/sales-terminal');
        this.snackService.showError(this.translateService.instant('general.api_event_status_invalid'));
      } else if (this.event.assignedStates.includes(EventStateEnum.SaleWithCode)) {
        this.snackService.showInfo(this.translateService.instant('general.api_event_only_tickets_with_code'));
      }
      this.refundService.canRefund(this._eventId).pipe(
        finalize(() => this.stopLoader()),
        tap({error: () => this.salespointHasRefundRight = false})
      ).subscribe(() => this.salespointHasRefundRight = true);
    });
  }

  private get hasAllowedStatus(): boolean {
    if (this.isPreparation) {
      return  this.authService.checkPrivileges(Privileges.EVENT_VIEW_PREPARATION);
    }
    return ![STATUS_PAST, STATUS_SUSPENDED, STATUS_CANCELLED].includes(this.event.status.id);
  }

  public get isPreparation(): boolean {
    return this.event?.status?.id === STATUS_DRAFT;
  }

  private get hasAllowedState() {
    const notAllowedStates = [EventStateEnum.SoldOut, EventStateEnum.TicketsCurrentlyUnavailable]
    return !this.event.assignedStates.some(value => notAllowedStates.includes(value));
  }

  public openEventDetails() {
    const ref = this.dialog.open(EventDetailsDialogComponent, {
      width: '60%',
      data: {
        event: this.event,
        displayNavigateToEvent: true
      }
    });
    ref.afterClosed().subscribe((action) => {
      if (action === TO_EVENT_BO_VIEW) {
        this.routeService.navigate('/app/back-office/events/view/' + this.event.eventId);
      } else {
        this.initEventDetails();
      }
    });
  }

  // check whether the user has refund all privilege OR whether the salespoint has the right to do refunds and user has refund privileges
  public get isRefundVisible(): boolean {
    return !this.event.boEvent && (this.authService.checkPrivileges(Privileges.REFUND_ALL) ||
      (this.salespointHasRefundRight && this.authService.checkPrivileges(
        [Privileges.REFUND_SALES_TERMINAL, Privileges.REFUND_WEB, Privileges.REFUND_PROMOTER, Privileges.REFUND_EXPIRED])));
  }
  public get canRefundFromVenueMap(): boolean {
    return this.authService.checkPrivileges(Privileges.VENUEMAP_REFUND) && this.selectedSector && this.selectedSector.hasSeats;
  }

  public openTicketRangeInput(exchange = false): void {
    const dialogRef = this.dialog.open(RefundDialogComponent, {
      data: {
        exchange: exchange,
        eventId: this.event.eventId
      }
    });
    dialogRef.afterClosed().subscribe();
  }
  public refundModeStart(): void {
    this.refundMode = true;
    this.storageService.set(RefundService.STORAGE_REFUND_EXCHANGE, false);
  }

  public startLoader(): void {
    this._scrollTop = cloneDeep(this.utilService.contentScrolledTop);
    if (!this.isLoading) {
      this._finished = false;
      setTimeout(() => {
        if (!this._finished) {
          this.isLoading = true;
        }
      }, 500);
    }
  }
  public stopLoader(): void {
    this.isLoading = false;
    this._finished = true;
    this.storageService.set(UtilService.STORAGE_CONTENT_SCROLL, this._scrollTop);
  }

  public openEventBookings(): void {
    this.routeService.navigate('/app/sales-terminal/bookings')
      .then(() => this.utilService.bookingQueried.next({id: this.event.eventId, title: this.event.title}));
  }

  public openReportOverview(): void {
    this.routeService.navigate('/app/reports/events/' + this.event.eventId);
  }

  // New functions
  public get getStatusBadgeClass(): string {
    return this.utilService.getEventStatusBadge(this.event?.status?.id);
  }

  getStateBadgeClass(state: string): string {
    return this.utilService.getEventStateBadge(state as EventStateEnum);
  }

  public updateSeats(): void {
    const cartEvent: CartEvent = cloneDeep(this.cartService.events?.find((e: CartEvent) => e?.id === this.event?.eventId));
    const seatIds: number[] = cartEvent?.legacyTickets?.map((seatTicket: LegacyTicket) => (seatTicket.seatId)) || [];
    this.deselectedSeatIds = this.selectedSeatIds.filter(seat => (!seatIds.includes(seat)));
    this.selectedSeatIds = seatIds;
  }
  public removeSeats(tickets: LegacyTicket[]): void {
    this.startLoader();
    const hasPromocode = !!cloneDeep(this.cartService.cart.legacyPromocode);
    const ticketIds: TicketIds = {tickets: []};
    tickets.forEach((ticket: LegacyTicket) => ticketIds.tickets.push(ticket.id));
    this.cartService.removeCartTickets(ticketIds).pipe(
      finalize(() => this.stopLoader())
    ).subscribe(cart => {
      this.updateCartForPurchase(true);
      if (hasPromocode && !cart.legacyPromocode) {
        this.storageService.set(CartService.STORAGE_CART_PROMOCODE_REMOVED, moment.now());
      }
    });
  }

  public addTicketsToBooking(bookingId: number): void {
    this.bookingsService.addTickets({tickets: this.cartService.getEventTicketIds(this._eventId)}, bookingId).subscribe(bookingId => {
      this.cartService.retryCart();
      this.routeService.navigate('/app/sales-terminal/bookings/view/' + bookingId.id);
      this.snackService.showSuccess(this.translateService.instant('general.api_cart_tickets_added_to_booking'));
    });
  }

  public get hasCorrectEventType(): boolean {
    return this.cartService.isEmpty || (this.event.boEvent && this.cartService.isSelfService) || (!this.event.boEvent && this.cartService.cartType !== CartTypes.SelfService);
  }
}
